(function () {
  var locked = false;

  function headerOffset() {
    var header = document.querySelector('.site-header--sticky.site-header--opening') || document.querySelector('.diagnox-header.site-header, .site-header');
    if (!header) return 0;
    var rect = header.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top > 1) return 0;
    return Math.round(rect.bottom);
  }

  function updateStuck(nav) {
    var spacer = nav.previousElementSibling;
    if (!spacer || !spacer.hasAttribute('data-support-tabs-spacer')) spacer = null;
    var offset = headerOffset();
    nav.style.setProperty('--spt-top', offset + 'px');
    var stuck = nav.classList.contains('is-stuck');
    var anchorTop = stuck && spacer ? spacer.getBoundingClientRect().top : nav.getBoundingClientRect().top;

    if (!stuck && anchorTop <= offset) {
      if (spacer) spacer.style.height = nav.offsetHeight + 'px';
      nav.classList.add('is-stuck');
    } else if (stuck && spacer && spacer.getBoundingClientRect().top > offset) {
      nav.classList.remove('is-stuck');
      spacer.style.height = '0px';
    }
  }

  function isPageAnchor(link) {
    var href = link.getAttribute('href') || '';
    return href.charAt(0) === '#';
  }

  function targetsFor(nav) {
    return Array.prototype.map.call(nav.querySelectorAll('[data-support-tab]'), function (link) {
      if (!isPageAnchor(link)) return null;
      var id = link.getAttribute('data-anchor');
      var target = id ? document.getElementById(id) : null;
      return { link: link, target: target };
    }).filter(function (item) {
      return item && item.target;
    });
  }

  function setActive(nav, link) {
    nav.setAttribute('data-active', link.getAttribute('data-anchor') || '');
    nav.querySelectorAll('[data-support-tab]').forEach(function (item) {
      var active = item === link;
      item.classList.toggle('is-active', active);
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
    keepInView(nav, link);
  }

  function keepInView(nav, link) {
    var list = nav.querySelector('[data-support-tabs-list]');
    if (!list || list.scrollWidth <= list.clientWidth) return;
    var listRect = list.getBoundingClientRect();
    var linkRect = link.getBoundingClientRect();
    var delta = linkRect.left - listRect.left - (listRect.width - linkRect.width) / 2;
    list.scrollTo({ left: list.scrollLeft + delta, behavior: 'smooth' });
  }

  function scrollToTarget(nav, target) {
    var navHeight = nav.getBoundingClientRect().height;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - navHeight + 1;
    locked = true;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    window.setTimeout(function () {
      locked = false;
    }, 700);
  }

  function init(nav) {
    if (nav.getAttribute('data-spt-ready') === 'true') return;
    nav.setAttribute('data-spt-ready', 'true');

    var items = targetsFor(nav);
    items.forEach(function (item) {
      item.target.classList.add('support-page-anchor');
    });

    nav.querySelectorAll('[data-support-tab]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('data-anchor');
        var target = id ? document.getElementById(id) : null;
        if (!target || !isPageAnchor(link)) return;
        event.preventDefault();
        setActive(nav, link);
        scrollToTarget(nav, target);
        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', '#' + id);
        }
      });
    });

    function onScroll() {
      updateStuck(nav);
      if (locked) return;
      var marker = headerOffset() + nav.getBoundingClientRect().height + 24;
      var current = items[0];
      items.forEach(function (item) {
        if (item.target.getBoundingClientRect().top <= marker) current = item;
      });
      if (!current) return;
      var nextId = current.link.getAttribute('data-anchor');
      if (nav.getAttribute('data-active') === nextId) return;
      nav.setAttribute('data-active', nextId);
      setActive(nav, current.link);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (nav.classList.contains('is-stuck')) {
        var spacer = nav.previousElementSibling;
        if (spacer && spacer.hasAttribute('data-support-tabs-spacer')) {
          spacer.style.height = nav.offsetHeight + 'px';
        }
      }
      updateStuck(nav);
    });
    onScroll();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-type="support-tabs"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    event.target.querySelectorAll('[data-section-type="support-tabs"]').forEach(function (nav) {
      nav.removeAttribute('data-spt-ready');
      init(nav);
    });
  });
})();
